import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import './checkout.css'
const Order = ({addressDetails}) => {
  const cart = useSelector(state => state.cart)
  const user = JSON.parse(localStorage.getItem('user'))
  const [productsNames, setProductsNames] = useState([])

  const getProductsNames = async () => {
    cart?.cartItems.map(async (product) => {
      const data = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/allItems/find/${product.productId}`)
      .then(res => {
        setProductsNames([...productsNames, res.data.title])
      }).catch(err => {
        console.log("err is", err);
      })
    })
  }

  useEffect(() => {
    getProductsNames()
  }, [cart])

  return (
    <>
      <h1 style={{textAlign: 'center'}}>Thank you for your order {user?.username}</h1>
      <div className="addressDetails">
          <h3>Name: {addressDetails?.name}</h3>
          <h3>Surname: {addressDetails?.surname}</h3>
          <p>Country: {addressDetails?.country}</p>
          <p>Region: {addressDetails?.region}</p>
          <p>City: {addressDetails?.city}</p>
          <p>Street: {addressDetails?.street}</p>
          <p>Zipcode: {addressDetails?.zipcode}</p>
          <p>Total: 100$</p>
      </div>
    
      <div className="orderDetails">
        <h3>Products</h3>
        {cart?.cartItems.map((product, index) => (
          <div className="productDetails">
            <p style={{marginRight: '10px'}}>{productsNames[index]}</p>
            <p>Quantity: {product.cartQuantity}</p>   
          </div>
        ))}
      </div>
      
    </>

  )
}

export default Order